import React, { useCallback } from 'react';
import { isExternalUrl } from 'js/utils/url.util';
import { kambiNavigate } from '../../../utils/url.utils';
import { Link as CoreLink } from 'js/components/common/Link/Link';
import { useGetPageRoutingURL } from '../../../hooks/useGetPageRoutingURL';

export const Link = (props) => {
    const { href, onClick, inNewWindow, ...other } = props;
    const linkPath = useGetPageRoutingURL(href);

    const onLinkClick = useCallback((event) => {
        onClick?.(event);

        if (/\/kambi#/.test(linkPath)) {
            kambiNavigate(linkPath);
        }
    }, [linkPath, onClick]);

    const target = inNewWindow || isExternalUrl(href) ? '_blank' : '_self';

    return <CoreLink href={href} onClick={onLinkClick} inNewWindow={inNewWindow} target={target} {...other} />;
};
